export const SkillNames: {
  BladesIntuition: string;
  Cloak: string;
  Marksman: string;
  WeaponProficiency: string;
  ShortCircuit: string;
  DigitalObserver: string;
  Tracer: string;
  Overclock: string;
  Reaper: string;
  EvasiveSystem: string;
  Datamancer: string;
  CybersEdge: string;
  HandsOfMidas: string;
  Hyperdrive: string;
} = {
  BladesIntuition: "Blade's Intuition",
  Cloak: "Cloak",
  Marksman: "Marksman",
  WeaponProficiency: "Weapon Proficiency",
  ShortCircuit: "Short-Circuit",
  DigitalObserver: "Digital Observer",
  Tracer: "Tracer",
  Overclock: "Overclock",
  Reaper: "Reaper",
  EvasiveSystem: "Evasive System",
  Datamancer: "Datamancer",
  CybersEdge: "Cyber's Edge",
  HandsOfMidas: "Hands of Midas",
  Hyperdrive: "Hyperdrive",
};
